import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'contextual-summary.project-summary.types-of-work.title',
		defaultMessage: 'Types of work',
		description: 'Title of the breakdown by types of work section.',
	},
	description: {
		id: 'contextual-summary.project-summary.types-of-work.description',
		defaultMessage: 'Get a breakdown of issues by their types. <link>View all items</link>',
		description: 'Description of the breakdown by types of work section.',
	},
	emptyDescription: {
		id: 'contextual-summary.project-summary.types-of-work.empty-description',
		defaultMessage:
			'Create some issues to view a breakdown of total work by issue type. <link>What are issue types?</link>',
		description: "Description of the breakdown by types of work section when there's no data.",
	},
	typeColumn: {
		id: 'contextual-summary.project-summary.types-of-work.type-column',
		defaultMessage: 'Type',
		description: 'Title for the type column of types of work section table.',
	},
	distributionColumn: {
		id: 'contextual-summary.project-summary.types-of-work.distribution-column',
		defaultMessage: 'Distribution',
		description: 'Title for the distribution column of types of work section table.',
	},
	counter: {
		id: 'contextual-summary.project-summary.types-of-work.counter',
		defaultMessage: 'issues',
		description: 'Text for the tooltip hover counter for the work section percentage bar.',
	},
});
